/**
 * @generated SignedSource<<06defe128f1ded3b42c3ecb440b205ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "style"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "styleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "style",
        "variableName": "style"
      },
      {
        "kind": "Variable",
        "name": "styleId",
        "variableName": "styleId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateStyle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateStyleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateStyleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "fc1f62ee703247427e037d0b132c87e6",
    "id": null,
    "metadata": {},
    "name": "UpdateStyleMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateStyleMutation(\n  $styleId: ID!\n  $style: StyleInput!\n) {\n  updateStyle(styleId: $styleId, style: $style) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "a31a9be89907b39165e649987b87a027";

export default node;
